import {RecognizeTextAsync} from '~/aws/lexClient';
import {Fragment, useEffect, useState} from "react";
import {UserLocationMap, PaymentAnalysis, RealtimeMiniBarChart, UsersPerMonthBarChart
, ChatHeatmap, TopUsersChart, ChatPerMonth, UserByPlanChart, RevenueByPlanChart,
RevenueByMonthChart, PaymentSuccessGauge, StatisticCard} from './component';
import DashboardAPI from '~/api/dashboardApi';
function DashBoard() {
    const [data, setData] = useState({});
    useEffect(() => {
        DashboardAPI.getDatas()
            .then((res) => {
                setData(res.data);
            })
            .catch((err) => {
                ;
            })
    }, [])
    return (
        <Fragment>
            <div className="col-xxl-6 mb-10">
                <StatisticCard/>
            </div>
            <div className="row gx-6 mb-10">
                <div className="col-12 col-xl-6">
                    <RealtimeMiniBarChart userCountryOverview={data.UserCountryOverview} />
                </div>
                <div className="col-12 col-xl-6">
                    <UsersPerMonthBarChart websiteVisitorYears = {data.WebsiteVisitorYears} />
                </div>
            </div>
            <div className="row gx-6 mb-10">
                <div className="col-12 col-xl-6">
                    <PaymentAnalysis paymentAnalysis={data.PaymentAnalysis}
                                     paymentAnalysisTotal={data.PaymentAnalysisTotal}/>
                </div>
                <div className="col-12 col-xl-6">
                    <UserLocationMap registerUsersLocation={data.RegisteredUsersLocation}/>
                </div>
            </div>
            <div className="row gx-6 mb-10">
                <div className="col-12 col-xl-8">
                    <ChatPerMonth chatPerMonth={data.ChatPerMonth}/>
                </div>
                <div className="col-12 col-xl-4">
                    <TopUsersChart topUserChat = {data.TopUserChat}/>
                </div>
            </div>
            <div className="row gx-6 mb-10">
                <div className="col-12 col-xl-6">
                    <ChatHeatmap/>
                </div>
                <div className="col-12 col-xl-6">
                </div>
            </div>
            <div className="row gx-6 mb-10">
                <div className="col-12 col-xl-8">
                    <UserByPlanChart userByPlan = {data.UserBySubscriptionPlan}/>
                </div>
                <div className="col-12 col-xl-4">
                    <RevenueByPlanChart revenueBySubscriptionPlan={data.RevenueBySubscriptionPlan}/>
                </div>
            </div>
            <div className="row gx-6 mb-10">
                <div className="col-12 col-xl-6">
                    <RevenueByMonthChart revenueBySubscriptionPerMonth={data.RevenueBySubscriptionPerMonth}/>
                </div>
                <div className="col-12 col-xl-6">
                    <PaymentSuccessGauge/>
                </div>
            </div>
        </Fragment>
    )
}
export default DashBoard;